<div class="row g-3">
  @if (hasCheckbox()) {
    <div class="col-auto">
      <div class="form-check">
        <input
          class="form-check-input"
          [ngClass]="{ 'is-invalid': isErrorVisible() }"
          type="checkbox"
          [required]="isCheckboxMandatory()"
          [checked]="item().checkbox.initialValue"
          [attr.id]="item().id"
          [attr.data-test]="'approval-form-item-cb-' + item().id"
          [attr.aria-describedby]="labelId() + ' ' + errorId()"
          [attr.aria-invalid]="isErrorVisible()"
          (change)="onCheckBoxChanged($event.target.checked)"
        />
      </div>
    </div>
  }
  <div class="col">
    @if (hasCheckbox()) {
      <label
        class="text-secondary fw-semibold mb-2 d-block"
        [for]="item().id"
        [attr.id]="labelId()"
        [attr.data-test]="'approval-form-item-label-' + item().id"
        [translate]="item().checkbox.label"
      ></label>
    }

    @if (hasBulletPoints()) {
      <ul class="list-ul mb-0">
        @for (point of item().bulletPoints; track $index) {
          <li class="my-1">
            <p class="mb-0">
              @if (!!point.link) {
                <a [href]="point.link" [translate]="point.label" [translateParams]="point.labelParams" target="_blank"></a>
              } @else {
                <a
                  href="#"
                  (click)="$event.preventDefault(); this.priceSheetService.openPriceSheet(point.isuTariffKey)"
                  [translate]="point.label"
                  [translateParams]="point.labelParams"
                ></a>
              }
            </p>
          </li>
        }
      </ul>
    }

    @if (hasText()) {
      <p class="mb-0" [id]="'approval-form-item-text-' + item().id" [innerHTML]="item().text | translate: item().textParams | safeHtml"></p>
    }

    @if (isErrorVisible()) {
      <span [translate]="item().checkbox.error" [id]="errorId()" class="invalid-feedback d-block"></span>
    }
  </div>
</div>
